// Scroll-snap carousel: --prev/--next commands scroll the track by one slide width.
class SCarousel extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    this.addEventListener('command', (event) => {
      const step = event.command === '--next' ? 1 : event.command === '--prev' ? -1 : 0;
      const track = this.querySelector('[data-carousel-track]');
      if (!step || !track) return;
      const rtl = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
      const atEnd = track.scrollLeft * rtl + track.clientWidth >= track.scrollWidth - 4;
      const atStart = track.scrollLeft * rtl <= 4;
      const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const behavior = reduce ? 'auto' : 'smooth';
      // Wrap around at either end so the arrows never dead-end.
      if (step > 0 && atEnd) return track.scrollTo({ left: 0, behavior });
      if (step < 0 && atStart) return track.scrollTo({ left: rtl * track.scrollWidth, behavior });
      track.scrollBy({ left: step * rtl * track.clientWidth, behavior });
    }, { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

customElements.get('s-carousel') || customElements.define('s-carousel', SCarousel);
